import "features/cases/blocks/CommonCard/elements/RestoreDraftBanner/RestoreDraftBanner.css";
import React from "react";
import BubbleButton from "ui/BubbleButton";

const RestoreDraftBanner = ({
  onRestore,
  onDiscard,
}: {
  onRestore: () => void;
  onDiscard: () => void;
}) => (
  <div className="restore-draft-banner">
    <span className="restore-draft-banner__text">
      Найдены несохранённые изменения в этом браузере.
    </span>
    <BubbleButton
      className="restore-draft-banner__button"
      size="s"
      onClick={onRestore}
      text="Восстановить"
      autosize={false}
      square={false}
    />
    <BubbleButton
      className="restore-draft-banner__button"
      size="s"
      onClick={onDiscard}
      text="Удалить"
      autosize={false}
      square={false}
    />
  </div>
);

export default RestoreDraftBanner;
